<div
  #wrapperImage
  [class.flex]="keepAspectRatio()"
  [class.items-center]="keepAspectRatio()"
  [class.justify-center]="keepAspectRatio()"
  [class.size-full]="keepAspectRatio() || isFullWidth()"
  [class.w-full]="!keepAspectRatio() && !isFullWidth()"
  class="relative overflow-hidden [contain:content]">
  @if (isLoading()) {
    <div [ngStyle]="{ 'width.px': width(), 'height.px': height() }" class="absolute animate-pulse bg-[#e5e7eb]"></div>
  }
  @if (isError()) {
    <div
      [ngStyle]="{ 'width.px': width(), 'height.px': height() }"
      class="flex items-center justify-center bg-[#e5e7eb]">
      <svg
        class="size-8 opacity-20"
        fill="none"
        stroke="currentColor"
        stroke-width="1.5"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"
          stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
    </div>
  } @else {
    @if (width() && height() && imagesArray()) {
      @for (image of imagesArray(); track image.randomId) {
        <div
          [class.relative]="!isFullWidth()"
          [class.w-full]="isFullWidth()"
          [ngStyle]="isFullWidth() ? { 'height.px': height() } : { 'width.px': width(), 'height.px': height() }"
          class="overflow-hidden">
          @if (image.cdnLink; as src) {
            <!--
                                        Do not use NgOptimizedImage here.
                        
                                        Reason: On the server, NgOptimizedImage's "priority" behavior injects
                                        a <link rel="preload"> for the image. That competes with truly critical
                                        preloads and can exhaust our limited preload budget. We reserve preloads
                                        for fonts and a few hand-picked assets.
                        
                                        Implementation: We use a plain <img> and explicitly set:
                                        - fetchpriority="high" and loading="eager" for the LCP image,
                                        - width/height to avoid layout shifts,
                                        - srcset/sizes managed manually for responsive images.
                                        This gives us LCP prioritization without the SSR preload side effect.
                        
                                        Trade-off: We forgo NgOptimizedImage conveniences (auto warnings, helpers)
                                        in exchange for tighter control over preload usage and network scheduling.
                                    -->
            <img
              (error)="onError()"
              (load)="setLoadingFalse()"
              [alt]="image.alt"
              [attr.decoding]="isPriority() ? 'sync' : 'async'"
              [attr.fetchpriority]="isPriority() ? 'high' : 'auto'"
              [attr.loading]="isPriority() ? 'eager' : 'lazy'"
              [class]="customClass()"
              [src]="src"
              [attr.srcset]="image.cdnSrcset"
              [attr.sizes]="image.cdnSizes"
              [class.transition-transform]="hoverEffect()"
              [class.duration-300]="hoverEffect()"
              [class.ease-in-out]="hoverEffect()"
              [class.group-hover:scale-110]="hoverEffect()"
              class="absolute inset-0 size-full object-cover" />
            <!-- DEBUG: Uncomment following div to debug priority mode -->
            <!--
                                                        <div class="absolute inset-0 z-50 flex size-full items-center justify-center">
                                                          <span
                                                            class="inline-flex items-center rounded-md border border-[#fa5252] bg-[#fff5f5] px-2 py-1 text-sm font-medium text-[#fa5252]">
                                                            {{ isPriority() ? "high" : "auto" }}
                                                          </span>
                                                        </div>
                                                        -->
          }
        </div>
      }
    }
  }
</div>
